// AUTH-03 Create account.
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Button, Form } from "react-aria-components";
import { api, call } from "../../api/client";
import { describeError } from "../../api/errors";
import { session, type AuthSession } from "../../api/session";
import { Banner } from "../../components/Banner";
import { AuthLayout } from "./AuthLayout";
import { Field } from "./fields";

export function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      const res = await call(api.POST("/auth/signup", { body: { email, password } }));
      if (res && "access_token" in res) await session.start(res as unknown as AuthSession);
      setDone(true);
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout title="Create your account" footer={<Link to="/sign-in">Already have an account? Sign in</Link>}>
      {done ? (
        <Banner>Check your email for a link to verify your address.</Banner>
      ) : (
        <>
          {error && <Banner tone="critical">{error}</Banner>}
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              void submit();
            }}
          >
            <Field label="Email" type="email" name="email" autoComplete="username" isRequired value={email} onChange={setEmail} autoFocus />
            <Field label="Password" type="password" name="password" autoComplete="new-password" minLength={12} maxLength={128} isRequired value={password} onChange={setPassword} />
            <Button type="submit" className="button primary wide" isPending={busy}>
              Create account
            </Button>
          </Form>
        </>
      )}
    </AuthLayout>
  );
}
